// src/screens/sales/promo/hooks/usePromo.ts

import { useCallback, useEffect, useState } from 'react'
import { PromoInterface } from '../../../../common/types/interfaces'
import { getSalesApi } from '../../../../salesApi/salesApi'
import { selectCurrentCluster } from '../../../../store/slices/currentClusterSlice'
import { useSelector } from 'react-redux'

export const initialValue: PromoInterface = {
  name: '',
  description: '',
  files: [],
  isActive: false,
  isVisible: false,
  startDate: new Date(),
  endDate: new Date(),
  discount: '',
  useItems: false,
  itemsFor: [],
  useCategories: false,
  categoriesFor: [],
  useStores: false,
  storesFor: [],
  useDiscountCode: false,
  discountCode: '',
  datesImportant: false,
  showText: true,
  sortOrder: '',
  forFirstPurchase: false, 
    forPickup: false,
  giftBySum: false,
  minSum: '',
  giftItemIds: []
}

export const usePromo = () => {
  const [modalActive, setModalActive] = useState<boolean>(false)
  const [modalActive1, setModalActive1] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false)
  const [salesApi] = useState(getSalesApi())
  const [data, setData] = useState<PromoInterface>({ ...initialValue })
  const [list, setList] = useState<PromoInterface[]>([])
  const [detailsModalActive, setDetailsModalActive] = useState<boolean>(false)
  const [current, setCurrent] = useState<PromoInterface>()
  const currentCluster = useSelector(selectCurrentCluster)
  const [loading, setLoading] = useState(true)

  const getList = useCallback(async () => {
    try {
      const result = await salesApi.getPromoList({ sort: 'name', order: 'ASC' })
      setLoading(false)
      if (result) setList(result.data)
    } catch (error) {
      setLoading(false)
    }
  }, [salesApi])

  const startCreate = (qr?: string) => {
    setCurrent(undefined)
    setData((prev) => ({ ...prev, barCode: qr }))
    setModalActive(true)
  }

  const startEdit = (el: PromoInterface) => {
    setCurrent({ ...el })
    setEdit(true)
    setModalActive(true)
  }

  const startMailing = (el: PromoInterface) => {
    setCurrent({ ...el })
    setModalActive1(true)
  }

  const showDetails = useCallback((el: PromoInterface) => {
    setCurrent(el)
    setDetailsModalActive(true)
  }, [])

  useEffect(() => {
    if (currentCluster) getList()
  }, [currentCluster, getList])

  useEffect(() => {
    if (!modalActive) setData(initialValue)
  }, [modalActive])

  return {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    modalActive1,
    setModalActive1,
    startMailing
  }
}